import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EmailJob, LanguageId } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<EmailJob & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Id', row => row.jobId),
		buildColumn(util, 'Text', row => row.jobTriggerName, { header: 'Job Name' }),
		buildColumn(util, 'Text', row => row.audienceName, { header: 'Audience' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.Espanol ? 'Spanish' : 'English', { header: 'Language' }),
		buildColumn(util, 'Text', row => row.function, { header: 'Function' }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.createdUTC, 'MMM D, YYYY', 'No Time', 'en-US'), { header: 'Created Date' }),
		buildColumn(util, 'Number', row => row.emailSentCount, { header: 'Emails Sent' }),
		buildColumn(util, 'Id', row => row.admissionsTrimesterId, { header: 'AdmissionsTrimesterId' }),
		buildColumn(util, 'Text', row => app.getTrimesterNameById(row.admissionsTrimesterId), { header: 'Admissions Trimester' }),
		buildColumn(util, 'Id', row => row.programmingTrimesterId, { header: 'ProgrammingTrimesterId' }),
		buildColumn(util, 'Text', row => app.getTrimesterNameById(row.programmingTrimesterId), { header: 'Programming Trimester' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'AccId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName' }),
		buildColumn(util, 'Number', row => row.bounceCount, { header: 'Bounces', hidden: true }),
	];


	return columns;

}